module.exports = __webpack_public_path__ + "img/img30.b1af96e6.svg";